import React from 'react';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import ControlButton from '../ControlButton/ControlButton';
import type { Controls } from '../../../useControls';

const GeolocateControl = ({ controls }: { controls: Controls }) => (
	<ControlButton
		actions={[
			{
				id: 'geolocate',
				label: 'Go to my location',
				icon: <MyLocationIcon />,
				onClick: controls.locateUser,
				dataCy: 'geolocate',
			},
		]}
	/>
);

export default GeolocateControl;
